import React from "react";
import { FieldEditTabProps } from "../../types";
import RequiredField from "../Constraints/RequiredField";
import { observer } from "mobx-react";
import { FragmentConstraints } from "../../FieldSerializer/fields/fragment";
import { requiredMappedErrors } from "../../../../services/FormUtils/DefinitionFieldMappedErrors";

function CustomFieldConstraints(props: FieldEditTabProps<FragmentConstraints>) {
  if (props.isArrayChildren) {
    return null;
  }
  return (
    <RequiredField
      relatedTabKey={"validationTab"}
      mappedErrors={requiredMappedErrors}
      onChange={(required) => props.onChangeConstraint("required", required)}
      value={props.constraints.required}
    />
  );
}

export default observer(CustomFieldConstraints);
